import { Card, CardBody, Col } from "reactstrap";
import CardHeaderCommon from "../../../../../CommonElements/CommonCardHeader/CardHeaderCommon";
import { Profit } from "../../../../../utils/Constant";
import { Badges, H2, P, SVG } from "../../../../../AbstractElements";
import ProfitChart from "./ProfitChart";

const ProfitSection = () => {
  return (
    <Col xl="12" lg="6">
      <Card className="profit">
        <CardHeaderCommon title={Profit} borderClass={true} headerClass="f-w-600" mainTitle="Yearly" firstItem="Today" secondItem="Tomorrow" thirdItem="Yesterday" />
        <CardBody className="profit-earning">
          <div className="d-flex">
            <Badges className="badge-rounded" color="">
              <SVG className="bit-icon animation" iconId="profit-up" />
            </Badges>
            <div className="flex-grow-1">
              <div className="d-flex">
                <H2 className="me-2">
                  $20.790,<span>00</span>
                </H2>
                <span className="bg-light-secondary me-2">
                  <SVG iconId="arrow-down" />
                </span>
                <span className="font-secondary">- 12.32%</span>
              </div>
              <P>Earned this month</P>
            </div>
            <ProfitChart />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ProfitSection;
